//constant.js
export const SET_LOADER = "SET_LOADER";
export const MY_API_ERROR = "MY_API_ERROR";

export const GET_RANDOM_QUESTION = "GET_RANDOM_QUESTION";
export const SET_RANDOM_QUESTION = "SET_RANDOM_QUESTION";

export const CHANGE_MODAL_STATE = "CHANGE_MODAL_STATE";

export const SET_FILTER_DATA = "SET_FILTER_DATA";
export const APPLY_FILTER_CONDITION = "APPLY_FILTER_CONDITION";
export const SET_APPLY_FILTER_CONDITION = "SET_APPLY_FILTER_CONDITION";
export const DISABLE_FILTER_CONDITION = "DISABLE_FILTER_CONDITION";

export const APPLY_SORT_CONDITION = "APPLY_SORT_CONDITION";
export const SET_APPLY_SORT_CONDITION = "SET_APPLY_SORT_CONDITION";
export const DISABLE_SORT_CONDITION = "DISABLE_SORT_CONDITION";

export const GET_THEME_COLOR = "GET_THEME_COLOR";
export const SET_THEME_COLOR = "SET_THEME_COLOR";
export const CHANGE_THEME_COLOR = "CHANGE_THEME_COLOR";

export const CHANGE_GRAPH_STATE = "CHANGE_GRAPH_STATE";
export const CHANGE_FILTER_SEARCH_MODEL_STATE = "CHANGE_FILTER_SEARCH_MODEL_STATE";

export const GET_FILTER_SEARCH_DATA = "GET_FILTER_SEARCH_DATA";
export const SET_FILTER_SEARCH_DATA = "SET_FILTER_SEARCH_DATA";

export const CHANGE_API_STATE = "CHANGE_API_STATE";
export const CHANGE_CREATE_MODAL_SATATE = "CHANGE_CREATE_MODAL_SATATE";

